"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reserve = exports.Liabilities = exports.CommitmentAmount = exports.MaximumPrefundingAmount = exports.CashAdvanceRate = exports.LoanTapeField = exports.ReceivableAdvanceRate = exports.Reporting = exports.FinancialCovenant = exports.PortfolioCovenant = exports.CommonPostgresQuery = exports.CommonFacilityMetricsQuery = exports.GlobalRecurringDate = exports.ConcentrationLimit = exports.DeliverableReportProperty = exports.DeliverablePropertyDEPRECATED = exports.LoanProductMechanics = exports.FullFormulaConfigSchema = void 0;
const Date_1 = require("../Date");
const FormulaEngine = __importStar(require("../FormulaEngine"));
const Notifications = __importStar(require("../Notifications"));
const Report = __importStar(require("../Report"));
const Utils = __importStar(require("../Utils"));
const z = __importStar(require("zod/v4"));
// signature for a function that handles custom cash balance csv
// and converts to standard record.
const FormulaConfigSchema = z.object({
    engineVersion: z.enum(FormulaEngine.SupportedFormulaEngines),
    formula: z.string(),
});
exports.FullFormulaConfigSchema = z.object({
    engineVersion: z.enum(FormulaEngine.FullSupportedFormulaEngines),
    formula: z.string(),
});
var LoanProductMechanics;
(function (LoanProductMechanics) {
    LoanProductMechanics.VintageCurveFormulaDenominatorTypeIterable = [
        'normalizedInitialBalance',
        'exposure',
    ];
})(LoanProductMechanics || (exports.LoanProductMechanics = LoanProductMechanics = {}));
var DeliverablePropertyDEPRECATED;
(function (DeliverablePropertyDEPRECATED) {
    // @jendevelops TODO: add in slack notification
    DeliverablePropertyDEPRECATED.PreUploadNotificationTypes = [
        Notifications.BorrowerEmailType.deliverablesResponsiblePartyReminder,
        Notifications.BorrowerEmailType.deliverablesResponsiblePartyStatusUpdate,
    ];
    DeliverablePropertyDEPRECATED.PostUploadNotificationTypes = [
        Notifications.BorrowerEmailType
            .deliverablesResponsiblePartySubmitSubmission,
    ];
})(DeliverablePropertyDEPRECATED || (exports.DeliverablePropertyDEPRECATED = DeliverablePropertyDEPRECATED = {}));
var DeliverableReportProperty;
(function (DeliverableReportProperty) {
    DeliverableReportProperty.ConfigSchema = z.object({
        processOnUpload: z.array(z.enum(Report.UploadDownstreamProcess)),
    });
})(DeliverableReportProperty || (exports.DeliverableReportProperty = DeliverableReportProperty = {}));
/**
 * ============= CONCENTRATION LIMIT =============
 */
var ConcentrationLimit;
(function (ConcentrationLimit) {
    /**
     * ============= VALUE CONFIG =============
     */
    let Value;
    (function (Value) {
        // for normalizing a number or currency type to a percentage type in standard calculation
        Value.ValueTypeIterable = [
            'currency',
            'number',
            'percentage',
        ];
    })(Value = ConcentrationLimit.Value || (ConcentrationLimit.Value = {}));
    let Calculation;
    (function (Calculation) {
        Calculation.DeclarativeConfigIterable = [
            'weightedAverage',
            'standard',
            'exposureByGroup',
            'directInsert',
        ];
        Calculation.SourceConfigIterable = [
            'pointer',
            ...Calculation.DeclarativeConfigIterable,
        ];
        Calculation.ResolvedConfigIterable = [
            'resolvedPointer',
            ...Calculation.DeclarativeConfigIterable,
        ];
        Calculation.LimitTypeIterable = ['min', 'max'];
        let Filters;
        (function (Filters) {
            Filters.OrderByOperatorIterable = ['asc', 'desc'];
            Filters.InListConfigIterable = ['inList', 'notInList'];
            Filters.EqualOperatorIterable = ['equals', 'notEqual'];
            Filters.CompareOperatorIterable = [
                'lessThan',
                'greaterThan',
                'greaterThanOrEqual',
                'lessThanOrEqual',
            ];
            Filters.OperationTypeIterable = [
                'orderBy',
                'orderBySum',
                'notEqual',
                'equals',
                'lessThan',
                'greaterThan',
                'greaterThanOrEqual',
                'lessThanOrEqual',
                'inList',
                'notInList',
            ];
        })(Filters = Calculation.Filters || (Calculation.Filters = {}));
        Calculation.WeightingIterable = [
            'eligibleExposureLessConcentrationKickout',
            'constant',
        ];
    })(Calculation = ConcentrationLimit.Calculation || (ConcentrationLimit.Calculation = {}));
})(ConcentrationLimit || (exports.ConcentrationLimit = ConcentrationLimit = {}));
/**
 * ============================================
 * ======    GLOBAL RECURRING DATE     ========
 * ============================================
 *
 * This set up is to represent configs that will help generate
 * dynamic date lists based on our recurring date mechanics.
 * Currently being used by PortCovs & Reporting Mechanics
 */
var GlobalRecurringDate;
(function (GlobalRecurringDate) {
    GlobalRecurringDate.SetupTypeIterable = ['static', 'relative'];
})(GlobalRecurringDate || (exports.GlobalRecurringDate = GlobalRecurringDate = {}));
/**
 * ============================================
 *            COMMON FACILITY METRICS QUERY
 * ============================================
 *
 * Currently being used by accrued liabilities and reserve
 *
 * TODO: @sachinr4 to consolidate with CommonPostgresQuery
 */
var CommonFacilityMetricsQuery;
(function (CommonFacilityMetricsQuery) {
    // *********************************************
    //        FINAL FACILITY METRICS QUERY STRUCTURES
    // *********************************************
    let Query;
    (function (Query) {
        Query.FacilityMetricsQueryTypeIterable = [
            'commitmentAmount',
            'unusedCommitment',
            'principalBalance',
            'interestRate',
            'receivableExposure',
            'receivableRepayment',
        ];
    })(Query = CommonFacilityMetricsQuery.Query || (CommonFacilityMetricsQuery.Query = {}));
})(CommonFacilityMetricsQuery || (exports.CommonFacilityMetricsQuery = CommonFacilityMetricsQuery = {}));
/**
 * ============================================
 *            COMMON POSTGRES QUERY
 * ============================================
 *
 * Currently being used by Portfolio Covenants, Financial Covenants, Reporting
 */
var CommonPostgresQuery;
(function (CommonPostgresQuery) {
    // *********************************************
    //        FINAL POSTGRES QUERY STRUCTURES
    // *********************************************
    let Query;
    (function (Query) {
        Query.PostgresQueryTypeIterable = [
            'assetVerification',
            'principalBalanceDailyAverage',
            'principalBalancePointInTime',
            'tAccountsSum',
            'orgProvidedInput',
        ];
    })(Query = CommonPostgresQuery.Query || (CommonPostgresQuery.Query = {}));
})(CommonPostgresQuery || (exports.CommonPostgresQuery = CommonPostgresQuery = {}));
/**
 * Portfolio Covenants operate generically in the following manner:
 *
 * Queries (Athena and Postgres) have variables that are primitives.
 * There is a special runtime variable `triggerDate` that always injected into the variable list.
 *
 * These variables can be then used in formulas to determine what parameterized values should be passed to a query implementation.
 * A common pattern will be to have `triggerDate` variable passed to a formula to determine `startDate` of a query
 * ie. startDate is the first of day of the previous month relative to the triggerDate
 *
 * The resulting evaluation of the formulas are then passed as parameters to the query implementation.
 * Postgres queries will pass as params to a method as there may be additional application logic.
 * Athena params are simply bound to the query with `?` binding pattern.
 *
 * The results of the athena or pg query are then made available to the intermediate fields (formula) from further evaluation.
 *
 * Athena results will be the first row of the resulting query, accessible by queryName.columnName in intermediate fields
 * ColumnNames are eagerly stored/validated in the config, unexpected column names are omitted in the response.
 *
 * Postgres results will resolve to singular primitive (application code wrapping the pg query will handle this), accessible by `name` in intermediate fields.
 *
 */
var PortfolioCovenant;
(function (PortfolioCovenant) {
    PortfolioCovenant.ValueTypes = ['currency', 'ratio', 'percentage'];
    /**
     * *** POSTGRES QUERIES ***
     */
    let PostgresQuery;
    (function (PostgresQuery) {
        PostgresQuery.QueryTypeIterable = [
            'principalBalanceDailyAverage',
            'principalBalancePointInTime',
            'tAccountsSum',
            'orgProvidedInput',
        ];
    })(PostgresQuery = PortfolioCovenant.PostgresQuery || (PortfolioCovenant.PostgresQuery = {}));
    /**
     * *** INTERMEDIATE FIELDS ***
     */
    PortfolioCovenant.RequiredIntermediateFieldIterable = [
        'triggerDate',
        'portfolioCovenantValue',
        'portfolioCovenantResult',
        'portfolioCovenantReportingDate',
    ];
})(PortfolioCovenant || (exports.PortfolioCovenant = PortfolioCovenant = {}));
/**
 * ============================================
 *             FINANCIAL COVENANTS
 * ============================================
 */
var FinancialCovenant;
(function (FinancialCovenant) {
    let LimitValueType;
    (function (LimitValueType) {
        LimitValueType["currency"] = "currency";
        LimitValueType["ratio"] = "ratio";
        LimitValueType["percentage"] = "percentage";
    })(LimitValueType = FinancialCovenant.LimitValueType || (FinancialCovenant.LimitValueType = {}));
    let LimitType;
    (function (LimitType) {
        LimitType["Min"] = "min";
        LimitType["Max"] = "max";
    })(LimitType = FinancialCovenant.LimitType || (FinancialCovenant.LimitType = {}));
    /**
     * *** POSTGRES QUERIES ***
     */
    let PostgresQuery;
    (function (PostgresQuery) {
        PostgresQuery.QueryTypeIterable = [
            'principalBalanceDailyAverage',
            'principalBalancePointInTime',
            'tAccountsSum',
            'orgProvidedInput',
        ];
    })(PostgresQuery = FinancialCovenant.PostgresQuery || (FinancialCovenant.PostgresQuery = {}));
    /**
     * *** INTERMEDIATE FIELDS ***
     */
    FinancialCovenant.RequiredIntermediateFieldIterable = [
        'triggerDate',
        'financialCovenantReportingDate',
        'financialCovenantValue',
        'financialCovenantResult',
    ];
})(FinancialCovenant || (exports.FinancialCovenant = FinancialCovenant = {}));
/**
 * ============================================
 * =============   REPORTING   ================
 * ============================================
 */
var Reporting;
(function (Reporting) {
    /**
     * *** POSTGRES QUERIES ***
     */
    let PostgresQuery;
    (function (PostgresQuery) {
        PostgresQuery.QueryArrayResultTypeIterable = ['assetVerification'];
    })(PostgresQuery = Reporting.PostgresQuery || (Reporting.PostgresQuery = {}));
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   DATA ACCESSOR   ************
        let DataAccessor;
        (function (DataAccessor) {
            DataAccessor.Methods = [
                'accruedLiabilities',
                'borrowingBaseMetrics',
                'creditAgreementMetrics',
                'fundingRequestMetrics',
                'invoiceMetrics',
                'loanMetrics',
                'orgProvidedInputs',
                'portfolioCovenantResults',
                'financialCovenantResults',
            ];
        })(DataAccessor = Inputs.DataAccessor || (Inputs.DataAccessor = {}));
    })(Inputs = Reporting.Inputs || (Reporting.Inputs = {}));
    // ========   OUTPUTS   ========
    let Outputs;
    (function (Outputs) {
        let Docx;
        (function (Docx) {
            // *******************************
            // ***  File Insertion Config  ***
            // *******************************
            Docx.FileInsertionTypeIterable = [
                'athenaQuery',
                'postgresQuery',
            ];
        })(Docx = Outputs.Docx || (Outputs.Docx = {}));
        let Xlsx;
        (function (Xlsx) {
            Xlsx.DataOutputTypeIterable = [
                'dataCellObject',
                'fileInsertion',
                'imageFileInsertion',
            ];
            // *******************************
            // ***  File Insertion Config  ***
            // *******************************
            Xlsx.FileInsertionTypeIterable = [
                'rawMasterLoanTape',
                'rawAssignedLoanTape',
                'rawCovenantLoanTape',
                'rawRepaymentTape',
                'rawSupplementalTape',
                'generatedMasterLoanTape',
                'generatedAssignedLoanTape',
                'generatedCovenantLoanTape',
                'generatedRepaymentTape',
                'generatedSupplementalTape',
                'extendedResponseTape',
                'newlyAssignedExtendedResponseTape',
                'borrowingBaseReserve',
                'statementDailySummary',
                'bankAccountScreenshot',
            ];
        })(Xlsx = Outputs.Xlsx || (Outputs.Xlsx = {}));
    })(Outputs = Reporting.Outputs || (Reporting.Outputs = {}));
    // ========   MAIN   ========
    Reporting.ReportTemplateFileTypeIterable = [
        'docx',
        'xlsx',
        'digital',
    ];
})(Reporting || (exports.Reporting = Reporting = {}));
/**
 * ============= RECEIVABLE ADVANCE RATE CONFIG =============
 */
var ReceivableAdvanceRate;
(function (ReceivableAdvanceRate) {
    ReceivableAdvanceRate.Types = ['formula', 'tree'];
})(ReceivableAdvanceRate || (exports.ReceivableAdvanceRate = ReceivableAdvanceRate = {}));
var LoanTapeField;
(function (LoanTapeField) {
    /**
     * ============= INTERMEDIATE CALCS =============
     */
    let IntermediateCalcs;
    (function (IntermediateCalcs) {
        // please ensure that this is subset of DataTapeField.Type
        IntermediateCalcs.ValidFieldTypes = [
            'integer',
            'optionalInteger',
            'string',
            'optionalString',
            'boolean',
            'optionalBoolean',
            'float',
            'optionalFloat',
            'date',
            'optionalDate',
            'percentage',
            'optionalPercentage',
        ];
    })(IntermediateCalcs = LoanTapeField.IntermediateCalcs || (LoanTapeField.IntermediateCalcs = {}));
})(LoanTapeField || (exports.LoanTapeField = LoanTapeField = {}));
/**
 * ============= CASH ADVANCE RATE CONFIG =============
 */
var CashAdvanceRate;
(function (CashAdvanceRate) {
    const MethodTypeSchema = z.literal('formula');
    const AbstractConfigSchema = z.object({ type: MethodTypeSchema });
    const FormulaSchema = AbstractConfigSchema.extend({
        type: z.literal('formula'),
        config: exports.FullFormulaConfigSchema,
    });
    CashAdvanceRate.ConfigSchema = FormulaSchema;
})(CashAdvanceRate || (exports.CashAdvanceRate = CashAdvanceRate = {}));
/**
 * Maximum Prefunding Amount Config
 */
var MaximumPrefundingAmount;
(function (MaximumPrefundingAmount) {
    const MethodTypeSchema = z.literal('formula');
    const AbstractConfigSchema = z.object({ type: MethodTypeSchema });
    const AvailableFormulaFieldsSchema = z.object({
        commitmentAmount: z.optional(z.number()),
    });
    MaximumPrefundingAmount.ConfigSchema = AbstractConfigSchema.extend({
        type: z.literal('formula'),
        config: FormulaConfigSchema,
    });
    // TO BE IMPLEMENTED LATER
    // | PointerConfig;
    // export type PointerConfig = AbstractConfig & {
    //   type: 'pointer';
    //   method: string;
    // };
    // after PointerConfig is fetched from database, it gets converted into ResolvedPointerConfig
    // by attaching the implementation to the method.
    // export type ResolvedPointerConfig = PointerConfig & {
    //   pointerImplementation: (
    //     conn: Knex
    //   ) => Promise<number>;
    // };
})(MaximumPrefundingAmount || (exports.MaximumPrefundingAmount = MaximumPrefundingAmount = {}));
/**
 * Commitment Amount Configuration
 */
var CommitmentAmount;
(function (CommitmentAmount) {
    CommitmentAmount.ConfigSchema = z.object({
        startDate: Utils.ZodFullDateStrStruct,
        endDate: Utils.ZodFullDateStrStruct,
        amount: z.number(),
    });
})(CommitmentAmount || (exports.CommitmentAmount = CommitmentAmount = {}));
/**
 * Account Configuration (for accruals and reserve)
 */
var Liabilities;
(function (Liabilities) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   INTERMEDIATE FIELDS   ************
        Inputs.RequiredIntermediateFieldIterable = z.enum([
            'accrualDate', // Represents the actual date of accrual, determined by accrual schedule
            'accrualValue', // Output used for final accrual amount
        ]);
        const CalcFormulaConfigSchema = FormulaConfigSchema.and(z.object({ type: z.literal('formula') }));
        const IntermediateFieldSchema = z.object({
            field: z.string(),
            config: CalcFormulaConfigSchema,
        });
        // ************   CONFIG   ************
        // Multiple configurations can be applied as an array to the same account
        // Accrual dates act as separate segments using start/end date properties
        // i.e. Original config from date A -> B, then amended config from B -> C
        Inputs.ConfigSchema = z.object({
            accrualDates: Date_1.RecurringDate.ConfigSchema,
            dataAccessors: z.array(z.any()), // to be replaced
            intermediateFields: z.array(IntermediateFieldSchema),
        });
    })(Inputs = Liabilities.Inputs || (Liabilities.Inputs = {}));
    const ConfigSchema = z.object({
        inputConfigurations: z.array(Inputs.ConfigSchema),
    });
})(Liabilities || (exports.Liabilities = Liabilities = {}));
var Reserve;
(function (Reserve) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   INTERMEDIATE FIELDS   ************
        Inputs.RequiredIntermediateFieldIterable = [
            'reportingDate', // Provided by borrowing base report
            'collectionsCash', // Provided by borrowing base report
            'borrowingBaseReserve', // Expected output for borrowing base reserve
            'collectionsReserve', // Expected output for cash reserve (collections)
        ];
    })(Inputs = Reserve.Inputs || (Reserve.Inputs = {}));
})(Reserve || (exports.Reserve = Reserve = {}));
//# sourceMappingURL=Config.js.map